import { WorkflowStep } from '../../workflow-navigation/reducers/workflow-step';
import { ScreenGuard } from './screen-index';
import { DeathSynopsis } from '../../assessment/synopsis';
import { WorkflowScreen } from '../../workflow-navigation/reducers/workflow-screen';
import { ClaimWorkflow } from './claim-workflow';
import { ClaimType } from '../../claim/claim-types';
import { DeathAssessmentView } from '../../assessment/decisions/death/views/death-assessment-view';
import { DashboardFlowView } from '../../assesor-dashboard/views/dashboard/assessor-dashboard';
import { PaymentsView } from '../../payment';
import { WorkflowUtilityScreen } from '../../workflow-navigation/reducers/workflow-utility-screen';
import { WorkflowAssessorScreen } from '../../workflow-navigation/reducers/workflow-assessor';
import { ClaimAuditTrailView } from '../../claim-audit-trail';
import { AuthGuard } from '../../auth/authGuard';

const screenGuardCapture = AuthGuard(['Agent', 'CentralPayments']);
const assessorDashboardGuard = AuthGuard(['AssessorDashboard']);

export const deathWorkflow = new ClaimWorkflow(
    'Death',
    [
        new WorkflowStep('Initiate Claim', []),
        new WorkflowStep('Assessment', [
            new WorkflowScreen('Synopsis', DeathSynopsis, undefined, undefined, () => true),
            new WorkflowScreen(
                'Decisions',
                DeathAssessmentView,
                undefined,
                undefined,
                screenGuardCapture
            ),
        ]),
        new WorkflowStep('Payments', [
            new WorkflowScreen('Payments', PaymentsView, undefined, undefined, screenGuardCapture),
        ]),
        new WorkflowAssessorScreen(
            'Assessor List',
            'Assessor limits dashboard',
            DashboardFlowView,
            undefined,
            'Assessor limits dashboard',
            assessorDashboardGuard
        ),
        new WorkflowUtilityScreen(
            'Claim Audit Trail',
            'list',
            ClaimAuditTrailView,
            undefined,
            undefined,
            screenGuardCapture
        ),
    ],
    claim => claim.claimType === ClaimType.Death,
    undefined,
    ScreenGuard
);
